export default __webpack_public_path__ + "static/media/ref-zol-kielce.28f37e45.pdf";